import React, { useState } from 'react';
import './GroupPricesModal.css';

const GroupPricesModal = ({ product, sellingPriceGroups, onClose, onSave, onSaveAndAddOpeningStock }) => {
  const [groupPrices, setGroupPrices] = useState(() => {
    // Initialize group prices if possible, otherwise empty
    const initial = {};
    sellingPriceGroups.forEach(grp => {
      initial[grp.id] = {
        price: '',
        type: 'Fixed'
      };
    });
    return initial;
  });

  const handlePriceChange = (grpId, value) => {
    setGroupPrices(prev => ({
      ...prev,
      [grpId]: { ...prev[grpId], price: value }
    }));
  };

  const handleTypeChange = (grpId, value) => {
    setGroupPrices(prev => ({
      ...prev,
      [grpId]: { ...prev[grpId], type: value }
    }));
  };

  const handleSave = (type) => {
    // Collect data and send to parent
    const data = {
      productId: product.id,
      prices: groupPrices
    };
    
    if (type === 'save_and_opening_stock') {
      onSaveAndAddOpeningStock(data);
    } else if (type === 'save_and_add_another') {
      onSave(data, true);
    } else {
      onSave(data, false);
      onClose();
    }
  };

  if (!product) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="modal-container group-prices-modal" 
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '1100px', width: '95%' }}
      >
        <div className="modal-header">
          <h2>Add or edit Group Prices</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="modal-content" style={{ width: '100%', maxWidth: 'none' }}>
          <div className="product-info-banner">
            Product: #{product.sku} {product.name} ({product.sku})
          </div>

          <table className="group-prices-table" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Default Selling Price (Inc. Tax)</th>
                {sellingPriceGroups.map(grp => (
                  <th key={grp.id}>
                    {grp.name}
                    <span className="info-icon-small" title={grp.description || 'Selling price group'}>i</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ verticalAlign: 'top', fontWeight: '500' }}>
                  $ {product.default_sell_price || product.price || '0.00'}
                </td>
                {sellingPriceGroups.map(grp => (
                  <td key={grp.id}>
                    <div className="price-input-group">
                      <input
                        type="number"
                        placeholder="0"
                        value={groupPrices[grp.id]?.price || ''}
                        onChange={(e) => handlePriceChange(grp.id, e.target.value)}
                      />
                      <select
                        value={groupPrices[grp.id]?.type || 'Fixed'}
                        onChange={(e) => handleTypeChange(grp.id, e.target.value)}
                      >
                        <option value="Fixed">Fixed</option>
                        <option value="Percentage">Percentage</option>
                      </select>
                    </div>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="group-prices-footer">
          <button 
            className="btn btn-save-stock" 
            onClick={() => handleSave('save_and_opening_stock')}
          >
            Save & Add Opening Stock
          </button>
          <button 
            className="btn btn-save-another" 
            onClick={() => handleSave('save_and_add_another')}
          >
            Save And Add Another
          </button>
          <button 
            className="btn btn-save-final" 
            onClick={() => handleSave('save')}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupPricesModal;
